import api from "./api";

export async function getDashboard() {
  const { data } = await api.get("/Dashboard");
  return data;
}
